<template>
  <div v-if="show === true" id="popup-no-facility-container" :class="$style.popup">
    <div :class="$style.cover"></div>
    <div :class="$style.wrapper">
      <p :class="$style.title"> 施設を表示できません </p>
      <div :class="$style.text">
        <p>
          この施設は現在ご利用いただけません。
        </p>
      </div>
      <div :class="$style.btnPanel">
        <span
          v-if="msg.btn.confirm"
          :class="$style.btnItem"
          :style="{ width: (1 / btns) * 100 + '%' }"
        >
          <span :class="[$style.btn, $style.confirm]" @click="okHandler">{{
            msg.btn.confirm
          }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PopupNoFacilityDetail',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      btns: 1,
      showPopup: true,
      msg: {
        close: false,
        btn: {
          confirm: 'OK',
        },
      },
    }
  },
  beforeCreate() {
    var exsistPopupEl = document.getElementById('popup-no-facility-container')
    if (exsistPopupEl) {
      document.body.removeChild(exsistPopupEl)
    }
  },
  updated() {
    this.btns = this.literal(this.msg.btn)
    if (!this.show) {
      document.body.style.position = '';
      document.body.style.width = '';
    } else {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  },
  methods: {
        okHandler() {
      this.$emit('ok')
    },

    literal(o) {
      const arr = []
      for (const k in o) {
        if (o[k]) {
          arr.push(o[k])
        }
      }
      return arr.length
    },
  },
}
</script>
<style lang="scss" module>
// @import '@design';
@media screen and (max-width: 560px) {
  body.modal-open {
    overflow: hidden;
    height: 100%;
  }
  .popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    .cover {
      width: 100vw;
      height: 100vh;
      background: #000;
      opacity: 0.6;
    }
    .wrapper {
      position: fixed;
      top: calc(50% - 12.5vh);
      left: 5vw;
      width: 90vw;
      max-height: 80%;
      padding: 15px;
      background: #fff;
      border-radius: 10px;
      box-sizing: border-box;
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .text {
        max-height: calc(80% - 110px);
        padding: 10px 0;
        overflow-y: auto;
      }
      .btnPanel {
        margin-top: 10px;
        text-align: center;
        span {
          display: inline-block;
        }
        .btnItem {
          text-align: right;
          .btn {
            box-sizing: border-box;
            width: 100%;
            height: 35px;
            line-height: 35px;
            text-align: center;
            cursor: pointer;
            border: 1px solid #070141;
            border-radius: 8px;
            }
          .confirm {
            color: #fff;
            background: #070141;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 560px) {
  .popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    .cover {
      width: 100vw;
      height: 100vh;
      background: #000;
      opacity: 0.6;
    }
    .wrapper {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 30%;
      max-height: 80%;
      padding: 15px;
      background: #fff;
      border-radius: 10px;
      box-sizing: border-box;
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .text {
        max-height: calc(80% - 110px);
        padding: 10px 0;
        overflow-y: auto;
      }
      .btnPanel {
        margin-top: 10px;
        text-align: center;
        span {
          display: inline-block;
        }
        .btnItem {
          text-align: right;
          .btn {
            box-sizing: border-box;
            width: 100%;
            height: 35px;
            line-height: 35px;
            text-align: center;
            cursor: pointer;
            border: 1px solid #070141;
            border-radius: 8px;
            }
          .confirm {
            color: #fff;
            background: #070141;
          }
        }
      }
    }
  }
}
</style>
